import React from 'react'
import { connect, useDispatch } from 'react-redux'

import { setLocation } from '@store/actionSlices/location'
import type { RootStateTypeExtra } from '@store/types'

import Container from '@components/container'
import DataHandler from '@components/data-handler'

import {
  LocationData,
  selectFromResult,
  useGetLocationQuery,
} from '@api/location'

export interface LocationProps {
  projectName: string
  location: Array<LocationData>
}

function Location({ projectName, location }: LocationProps) {
  const dispatch = useDispatch()

  const locationPayload = useGetLocationQuery(
    { projectName },
    { selectFromResult }
  )

  React.useEffect(() => {
    const { locations } = locationPayload

    if (location.length === 0 && locations.length > 0) {
      dispatch(setLocation(locations))
    }
  }, [locationPayload, location])

  return (
    <DataHandler
      payloads={{
        ...locationPayload,
        data: location,
      }}
    >
      <Container>Location Page</Container>
    </DataHandler>
  )
}

export default connect(
  ({ projectIdentity: { projectName }, location }: RootStateTypeExtra) => ({
    projectName,
    location,
  })
)(Location)
